<p-toast></p-toast>

<button
  pButton
  pRipple
  icon="pi pi-shopping-cart"
  class="p-button-rounded p-button-primary mr-2"
  (click)="onOpenItemsCart()"
  pTooltip="Carrito"
  tooltipPosition="left"
  [disabled]="!(table.data.length > 0)"
></button>

<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  [style]="{ width: '100%' }"
  (onHide)="onClose()"
>
  <ami-table-actions
    [settings]="table.settings"
    [data]="table.data"
    [actions]="table.actions"
    (action)="onReciveAction($event)"
  ></ami-table-actions>
</p-dialog>

<div *ngIf="openSideBar">
  <pg-product-of-provider-sidebar
    type="update"
    [item]="itemToSideBar"
    (close)="onCloseSideBar($event)"
  >
  </pg-product-of-provider-sidebar>
</div>

<p-dialog
  *ngIf="openConfirmRemove"
  [(visible)]="openConfirmRemove"
  header="Confirmar Eliminación"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  <div class="flex align-items-center justify-content-center">
    <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"></i>
    <span>¿Está seguro de que desea remover el producto del carrito?</span>
  </div>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      icon="pi pi-times"
      class="p-button-text"
      label="No"
      (click)="openConfirmRemove = false"
      pTooltip="Cancelar"
      tooltipPosition="bottom"
    ></button>
    <button
      pButton
      pRipple
      icon="pi pi-check"
      class="p-button-text"
      label="Si"
      (click)="removeItemCart()"
      pTooltip="Remover Producto"
      tooltipPosition="bottom"
    ></button>
  </ng-template>
</p-dialog>
